import { createReducer, on } from '@ngrx/store';
import * as CoinTypeActions from './coin-type.actions';
import { CoinType } from '../../models/CoinType';

export interface CoinTypeState {
  coinTypes: CoinType[];
  loading: boolean;
  error: any;
}

export const initialState: CoinTypeState = {
  coinTypes: [],
  loading: false,
  error: null,
};

export const coinTypeReducer = createReducer(
  initialState,
  on(CoinTypeActions.loadCoinTypes, (state) => ({ ...state, loading: true })),
  on(CoinTypeActions.loadCoinTypesSuccess, (state, { coinTypes }) => ({ ...state, loading: false, coinTypes })),
  on(CoinTypeActions.loadCoinTypesFailure, (state, { error }) => ({ ...state, loading: false, error })),

  on(CoinTypeActions.addCoinTypeSuccess, (state, { coinType }) => ({ ...state, coinTypes: [...state.coinTypes, coinType] })),
  on(CoinTypeActions.addCoinTypeFailure, (state, { error }) => ({ ...state, error })),

  on(CoinTypeActions.updateCoinTypeSuccess, (state, { coinType }) => ({
    ...state,
    coinTypes: [...state.coinTypes, coinType]
  })),
  on(CoinTypeActions.updateCoinTypeFailure, (state, { error }) => ({ ...state, error })),

  on(CoinTypeActions.deleteCoinTypeSuccess, (state, { id }) => ({
    ...state,
    coinTypes: state.coinTypes.filter(ct => ct.id !== id)
  })),
  on(CoinTypeActions.deleteCoinTypeFailure, (state, { error }) => ({ ...state, error })),
);
